const slugify = (text) => {
  if (!text || typeof text !== 'string') {
    return ''
  }

  return text
    .toString()
    .toLowerCase()
    .trim()
}

export default slugify
